module.exports = __webpack_public_path__ + "media/assets/icons/quality-7c500aad2acb66517912ba37bb9a3e46.svg";